module.exports = "/_next/static/images/photoDumitruPinzari-a9ab42ca4d6b7875980e501bff8c05eb.webp";